import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga';
import { Routes, Route } from 'react-router-dom';
import { getUserLocale } from 'get-user-locale';
import $ from 'jquery';

import Index from './pages/index/Index';
import DeleteAccount from './pages/delete-account/DeleteAccount';
import PrivacyPolicy from './pages/privacy-policy/PrivacyPolicy';
import translations from './utils/translations';

const App = () => {
  const [translationTexts, setTranslationTexts] = useState(null);

  ReactGA.initialize('G-NKV5LNT23K');
  ReactGA.pageview(window.location.pathname);

  const userLocale = getUserLocale();

  useEffect(() => {
    $.ajax({
      url: translations.getLocale(userLocale),
      dataType: 'json',
      cache: false,
      success: (data) => setTranslationTexts(data),
      error: (xhr, status, err) => console.log(err),
    });
  }, [userLocale]);

  return (
    translationTexts && (
      <div>
        <Routes>
          <Route path="/" element={<Index data={translationTexts} />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="/delete-account"
            element={<DeleteAccount data={translationTexts.deleteAccount} />}
          />
        </Routes>
      </div>
    )
  );
};

export default App;
